import { useAbility } from '@casl/react';
import * as React from 'react';
import { Navigate, Outlet, RouteProps, useLocation } from 'react-router';

import { useAuth } from '@barboxx/admin-utils';
import { Actions, Subjects } from '@barboxx/models/types';
import { AbilityContext } from '@barboxx/react-utils';
import { UserTypes } from '@barboxx/types';

export type ProtectedRouteProps = RouteProps & {
    allowedRoles: UserTypes[];
    redirect?: string;
};

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
    allowedRoles,
    redirect = '/restricted',
    children,
}) => {
    const { auth } = useAuth();
    const location = useLocation();
    const isAllowed = allowedRoles.includes(auth.user?.userType);

    if (!auth?.token) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (!isAllowed) {
        return <Navigate to={redirect} state={{ from: location }} replace />;
    }

    return children ? children : <Outlet />;
};

export type ProtectedCanRouteProps = RouteProps & {
    abilityAction: Actions;
    subject: Subjects;
    redirect?: string;
};

export const ProtectedCanRoute = ({
    abilityAction,
    subject,
    redirect = '/restricted',
    children,
}: ProtectedCanRouteProps) => {
    const ability = useAbility(AbilityContext);
    const location = useLocation();

    const isAllowed = ability.can(abilityAction, subject);

    if (!isAllowed) {
        return <Navigate to={redirect} state={{ from: location }} replace />;
    }

    return children ? children : <Outlet />;
};
